import PropTypes from 'prop-types';

// "Próximos 5 días hábiles" — a week strip of business days, each column listing
// the diligencias whose deadline (plazo) falls on that day. Presentational: the
// day buckets are derived upstream from the active diligencias' deadlines.
export default function Agenda({ days }) {
  return (
    <div className="agenda">
      {days.map((day) => (
        <div
          key={day.key}
          className={`agenda__day${day.hot ? ' agenda__day--hot' : ''}`}
        >
          <div className="agenda__date">
            <span className="agenda__dow">{day.dow}</span>
            <span className="agenda__dd">{day.dd}</span>
            {day.items.length > 0 && (
              <span className="agenda__n mono">{day.items.length}</span>
            )}
          </div>
          <div className="agenda__items">
            {day.items.length === 0 ? (
              <div className="agenda__empty mono">Sin plazos</div>
            ) : (
              day.items.map((it) => (
                <button
                  key={it.key}
                  type="button"
                  className="agenda__item"
                  onClick={it.onClick}
                >
                  <span className={`agenda__bar agenda__bar--${it.kind}`} />
                  <div>
                    <div className="agenda__what">{it.what}</div>
                    <div className="note">{it.secondary}</div>
                  </div>
                </button>
              ))
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

Agenda.propTypes = {
  days: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      dow: PropTypes.string.isRequired,
      dd: PropTypes.string.isRequired,
      hot: PropTypes.bool,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.string.isRequired,
          kind: PropTypes.string.isRequired,
          what: PropTypes.string,
          secondary: PropTypes.string,
          onClick: PropTypes.func,
        }),
      ).isRequired,
    }),
  ).isRequired,
};
